import { useState, useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
export var useNavigationBlock = function (showModalOnCancel, isSaving, blockListPath) {
    if (isSaving === void 0) { isSaving = false; }
    if (blockListPath === void 0) { blockListPath = false; }
    var _a = useState(false), showConfirmCancelEditModal = _a[0], setShowConfirmCancelEditModal = _a[1];
    var _b = useState(null), nextLocation = _b[0], setNextLocation = _b[1];
    var _c = useState(false), isBlocked = _c[0], setIsBlocked = _c[1];
    var history = useHistory();
    var continueNavigation = useCallback(function () {
        if (nextLocation) {
            setShowConfirmCancelEditModal(false);
            history.push(nextLocation.pathname + nextLocation.search);
            setIsBlocked(false);
            setNextLocation(null);
        }
    }, [history, nextLocation]);
    var keepEditHandler = useCallback(function () {
        setShowConfirmCancelEditModal(false);
        setIsBlocked(false);
    }, []);
    useEffect(function () {
        var unblock;
        if (!showModalOnCancel || isSaving) {
            return;
        }
        if (showModalOnCancel && !isBlocked) {
            // @ts-ignore
            unblock = history.block(function (next) {
                var isListPath = /^\/lists\/list\/[0-9a-fA-F-]+$/.test(next.pathname);
                if (isListPath && !blockListPath) {
                    return true;
                }
                setShowConfirmCancelEditModal(true);
                setNextLocation(next);
                setIsBlocked(true);
                return false;
            });
        }
        // here we need a clean-up function for useEffect
        // eslint-disable-next-line consistent-return
        return function () {
            if (unblock)
                unblock();
        };
    }, [showModalOnCancel, history, isBlocked, isSaving, blockListPath]);
    return {
        showConfirmCancelEditModal: showConfirmCancelEditModal,
        continueNavigation: continueNavigation,
        keepEditHandler: keepEditHandler,
        setShowConfirmCancelEditModal: setShowConfirmCancelEditModal,
        setNextLocation: setNextLocation
    };
};
